import Vue, { CreateElement } from 'vue'
import router from './router'
import app from './app.vue'

Vue.config.productionTip = false

import { Validator, install as VeeValidate } from 'vee-validate'
import { required, email, numeric } from 'vee-validate/dist/rules.esm.js'
import VeeJa from 'vee-validate/dist/locale/ja'
Validator.extend('required', required)
Validator.extend('email', email)
Validator.extend('numeric', numeric)
Validator.localize('ja', VeeJa)
Vue.use(VeeValidate, { inject: false, locale: VeeJa })

declare global {
  interface IntersectionObserver {
    POLL_INTERVAL: number
  }
}
import 'intersection-observer'
IntersectionObserver.prototype.POLL_INTERVAL = 100

import VueGtag from 'vue-gtag'
Vue.use(VueGtag, {
  config: {
    id: 'G-D9QC0ZQ89X'
  }
}, router)

new Vue({
  router,
  render: (h: CreateElement) => h(app)
}).$mount('#app')
